import React from 'react';

import styled from 'styled-components';

import { exercisePropTypes, HIGHLIGHT_SUCCESS, HIGHLIGHT_ERROR } from '../../../constants/exercise';
import RadioOption from '../../radio-group/radio-option';
import ChoiceChip from '../../choice-chip';
import { getCharByElementPosition } from '../../../lib/exercise';
import MathContent from '../../math-content';
import FluidContainer from '../../layouts/components/fluid-container';

const RadioOptionBox = styled.div`
    width: fit-content;
`;

const SingleAnswerContainer = styled.div`
    display: flex;
    font-size: 16px;
    padding: 0 32px 0 0;
`;

const RadioOptionContainer = styled.div`
    img {
        margin: 4px;
        vertical-align: middle;
    }
`;

const SingleFeedbackContainer = styled.div`
    margin-top: 8px;
`;

const SingleFeedback = styled.span`
    font-size: 16px;
`;

const SingleFeedbackLabel = styled.span`
    font-size: 16px;
    font-weight: 600;
    padding-bottom: 8px;
`;

const Index = styled.div`
    font-size: 16px;
    font-weight: 600;
    padding: 9px 16px 0 0;
`;

const SolutionContainer = styled.div`
    padding-top: 8px;
    display: flex;
    flex-direction: column;
`;

const SingleChoiceFeedback = ({ answers, exercise }) => {
    const correctAnswer = exercise.options.find((item) => item.correct);
    const correctAnswerIndex = exercise.options.indexOf(correctAnswer);

    const answered = answers.length === 1;

    let answerType;
    let answerToShow;
    let answerToShowIndex;

    if (answered) {
        answerToShow = exercise.options.find((item) => item.id === parseInt(answers[0]));
        answerToShowIndex = exercise.options.indexOf(answerToShow);
        answerType = correctAnswer.id === answerToShow.id ? HIGHLIGHT_SUCCESS : HIGHLIGHT_ERROR;
    } else {
        answerType = HIGHLIGHT_SUCCESS;
        answerToShow = correctAnswer;
        answerToShowIndex = correctAnswerIndex;
    }

    return (
        <FluidContainer marginBottom="mobile" marginTop={['mobile', 'mobile', 'desktop']}>
            <SingleAnswerContainer>
                <Index>{`${getCharByElementPosition(answerToShowIndex + 1)}.`}</Index>
                <RadioOptionContainer>
                    <RadioOptionBox>
                        <RadioOption id={exercise.id} disabled={true} highlight={answerType} selected={answered} value={answerToShowIndex}>
                            {answerToShow.text}
                        </RadioOption>
                    </RadioOptionBox>

                    <SingleFeedbackContainer>
                        <SingleFeedbackLabel>
                            {answered
                                ? answerType === HIGHLIGHT_SUCCESS
                                    ? 'Risposta esatta. '
                                    : 'Risposta sbagliata. '
                                : 'Risposta non data. '}
                        </SingleFeedbackLabel>
                        {answerToShow.feedback && (
                            <SingleFeedback>
                                <MathContent style={{ display: 'inline' }}>{answerToShow.feedback}</MathContent>
                            </SingleFeedback>
                        )}
                    </SingleFeedbackContainer>
                    {answerType === HIGHLIGHT_ERROR && (
                        <SolutionContainer>
                            <SingleFeedbackLabel>{`La risposta esatta è: ${getCharByElementPosition(
                                correctAnswerIndex + 1,
                            )}`}</SingleFeedbackLabel>
                            <div style={{ display: 'inline-block' }}>
                                <ChoiceChip type="validated" value={correctAnswer.text} disabled={true} />
                            </div>
                        </SolutionContainer>
                    )}
                </RadioOptionContainer>
            </SingleAnswerContainer>
        </FluidContainer>
    );
};
SingleChoiceFeedback.propTypes = exercisePropTypes.propTypes;

export default SingleChoiceFeedback;
